import React, {Component} from 'react'
import { Link } from 'react-router-dom'

class Cookies extends Component {
    state = {
        visible: true
    }
    hide = () => {
        this.setState({
            visible: false
        })
    }
    render() {
        return (
            this.state.visible &&
                <div className="cookies">
                    <div className="content">
                        <p>Utilizamos cookies propias y de terceros para mejorar nuestra web mediante el análisis de tu navegación en nuestro sitio. Si continuas navegando, consideraremos que aceptas su uso. Para más información, consulta nuestra 
                            <Link to="/politica-cookies" target="_blank"> Política de Cookies</Link>
                        </p>
                        <div className="cookies-options">
                            <span className="button bg-white ft-black cookies-accept" onClick={this.hide}><span>Aceptar</span></span>
                            <Link to="/politica-cookies" className="button bg-white ft-black" target="_blank"><span>Más info</span></Link>
                        </div>
                    </div>
                </div>
        )
    }
}

export default Cookies;